// Class: starling.assets.AssetType

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function starling_textures_Texture() {return require("./../../starling/textures/Texture");}
function starling_textures_TextureAtlas() {return require("./../../starling/textures/TextureAtlas");}
function openfl_media_Sound() {return $import(require("openfl/media/Sound"));}
function Xml() {return require("./../../Xml");}
function openfl_utils_ByteArray() {return $import(require("openfl/utils/ByteArray"));}
function starling_text_BitmapFont() {return require("./../../starling/text/BitmapFont");}
function starling_assets_AssetManager() {return require("./../../starling/assets/AssetManager");}

// Constructor

var AssetType = function(){}

// Meta

AssetType.__name__ = "starling.assets.AssetType";
AssetType.__isInterface__ = false;
AssetType.prototype = {
	
};
AssetType.prototype.__class__ = AssetType.prototype.constructor = $hxClasses["starling.assets.AssetType"] = AssetType;

// Init



// Statics

AssetType.fromAsset = function(asset) {
	if(((asset) instanceof (starling_textures_Texture().default))) {
		return AssetType.TEXTURE;
	} else if(((asset) instanceof (starling_textures_TextureAtlas().default))) {
		return AssetType.TEXTURE_ATLAS;
	} else if(((asset) instanceof (openfl_media_Sound().default))) {
		return AssetType.SOUND;
	} else if(((asset) instanceof (Xml().default))) {
		return AssetType.XML_DOCUMENT;
	} else if(((asset) instanceof (openfl_utils_ByteArray().default))) {
		return AssetType.BYTE_ARRAY;
	} else if(((asset) instanceof (starling_text_BitmapFont().default))) {
		return AssetType.BITMAP_FONT;
	} else if(((asset) instanceof (starling_assets_AssetManager().default))) {
		return AssetType.ASSET_MANAGER;
	} else {
		return AssetType.OBJECT;
	}
}
AssetType.TEXTURE = "texture"
AssetType.TEXTURE_ATLAS = "textureAtlas"
AssetType.SOUND = "sound"
AssetType.XML_DOCUMENT = "xml"
AssetType.OBJECT = "object"
AssetType.BYTE_ARRAY = "byteArray"
AssetType.BITMAP_FONT = "bitmapFont"
AssetType.ASSET_MANAGER = "assetManager"

// Export

exports.default = AssetType;